import { CircularProgress } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";

type IButtonLoginAndSearch = ButtonProps & {
  title: string;
  loading: boolean;
};

export const ButtonLoginAndSearch = ({
  title,
  loading,
  ...props
}: IButtonLoginAndSearch) => {
  return (
    <ButtonCore
      fullWidth
      disabled={loading}
      title={loading ? "Carregando..." : title}
      type="submit"
      endIcon={
        loading && (
          <CircularProgress size={20} sx={{ color: "#2c2ffa", ml: 4 }} />
        )
      }
      {...props}
    />
  );
};
